import {
    COURSE_PAGE_GET_REQUEST,
    COURSE_PAGE_GET_SUCCESS,
    COURSE_PAGE_GET_FAILURE,
    COURSE_CURRENT_OCCURRENCE_SET,
    OCCURRENCES_GET_REQUEST,
    OCCURRENCES_GET_SUCCESS,
    OCCURRENCES_GET_FAILURE,
    COURSE_SELECTED_DATE_SET,
} from '../actions/types';

export const initialState = {
    currentCourse: {},
    currentEducator: {},
    currentOccurrence: {},
    selectedDate: null,
    loading: true,
    occurrences: [],
    error: null,
    loadingOccurrences: true,
};

export default function course(state = initialState, action) {
    switch (action.type) {
        case COURSE_PAGE_GET_REQUEST:
            return {
                ...state,
                currentCourse: {},
                currentOccurrence: {},
                currentEducator: {},
                selectedDate: null,
                error: null,
                loading: true,
            };
        case COURSE_PAGE_GET_SUCCESS:
            return {
                ...state,
                ...action.payload,
                loading: false,
            };
        case COURSE_PAGE_GET_FAILURE:
            return {
                ...state,
                error: action.payload,
                loading: false,
                loadingOccurrences: false,
            };
        case COURSE_CURRENT_OCCURRENCE_SET:
            return {
                ...state,
                currentOccurrence: action.payload,
            };
        case COURSE_SELECTED_DATE_SET:
            return {
                ...state,
                selectedDate: action.payload,
            };
        case OCCURRENCES_GET_REQUEST:
            return {
                ...state,
                loadingOccurrences: true,
            };
        case OCCURRENCES_GET_SUCCESS:
            return {
                ...state,
                occurrences: action.payload,
                loadingOccurrences: false,
            };
        case OCCURRENCES_GET_FAILURE:
            return {
                ...state,
                occurrences: [],
                loadingOccurrences: false,
            };
        default:
            return state;
    }
}
